/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Content Intelligence — viewer. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  var root = document.querySelector('[data-ci="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-ci="' + k + '"]'); }

    /* Date range — normalised to the shared devicedetector picker. */
    function _hmT(k, v) { return (window.GS && GS.t) ? GS.t(k, v) : k; }
    function _hmYmd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
    function _hmToday() { var n = new Date(); return new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate())); }
    function _hmPreset(days) { var to = _hmToday(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: _hmT("an.last7"), 30: _hmT("an.last30"), 90: _hmT("an.last90"), 365: _hmT("an.last12mo") }[days] || (days + " days"); return { from: _hmYmd(from), to: _hmYmd(to), label: lbl, preset: String(days) }; }
    var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_ci_range") || "null"); if (s && s.preset) return _hmPreset(+s.preset); if (s && s.from && s.to) return s; } catch (e) {} return _hmPreset(30); })();
    function _hmSave() { try { localStorage.setItem("gs_ci_range", JSON.stringify(RANGE)); } catch (e) {} }
    (function initRange() {
      var scope = root; if (!scope) return;
      var btn = scope.querySelector('[data-ci="rangeBtn"]'), menu = scope.querySelector('[data-ci="rangeMenu"]'), lab = scope.querySelector('[data-ci="range-label"]');
      if (!btn || !menu) return;
      if (lab && RANGE.label) lab.textContent = RANGE.label;
      function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
      btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
      document.addEventListener("click", function (e) { if (!btn.contains(e.target)) menu.style.display = "none"; });
      function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; _hmSave(); menu.style.display = "none"; load(); }
      menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(_hmPreset(+b.getAttribute("data-preset"))); }); });
      var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var ff = menu.querySelector('[data-rp="from"]').value, tt = menu.querySelector('[data-rp="to"]').value; if (!ff || !tt) return; if (ff > tt) { var x = ff; ff = tt; tt = x; } apply({ from: ff, to: tt, label: ff + " \u2192 " + tt, preset: null }); });
    })();
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { n = +n || 0; return n >= 1e3 ? (n / 1e3).toFixed(1) + "k" : String(n); }
  function dur(s) { s = +s || 0; return s >= 60 ? Math.round(s / 60) + "m" + (s % 60 ? " " + (s % 60) + "s" : "") : s + "s"; }
  function band(r) { return r == null ? "#8C95A1" : r >= 70 ? "#1FA463" : r >= 45 ? "#D97706" : "#DC2626"; }

  function card(p) {
    return '<div class="cti-card" data-gs-page="' + esc(p.path) + '"><a class="cti-cpath" href="/heatmaps?page=' + encodeURIComponent(p.path) + '">'
      + esc(p.path) + "</a>"
      + '<div class="cti-cbar"><i style="width:' + Math.max(2, p.resonance == null ? 2 : p.resonance)
      + "%;background:" + band(p.resonance) + '"></i></div>'
      + '<div class="cti-cmeta"><b style="color:' + band(p.resonance) + '">'
      + (p.resonance == null ? "—" : p.resonance) + "</b> · " + esc(p.verdict)
      + " · " + p.scroll + "% scrolled · " + dur(p.dwell_s) + "</div></div>";
  }

  function renderList(key, rows) {
    var host = q(key); if (!host) return;
    if (!rows || !rows.length) { host.innerHTML = '<div class="empty">'+TR('conten.g.not_enough_measured_pages_yet')+'</div>'; return; }
    host.innerHTML = rows.map(card).join("");
  }

  function renderRows(d) {
    var host = q("rows"); if (!host) return;
    host.innerHTML = (d.pages || []).map(function (p) {
      /* Title carries the sum so the score can be argued with, not just accepted. */
      var tip = "depth " + p.depth_term + " · dwell " + p.dwell_term
              + (p.attention != null ? " · attention " + p.attention : "")
              + (p.friction != null ? " · minus 30% of friction " + p.friction : "");
      return '<tr data-gs-page="' + esc(p.path) + '"><td>' + '<a href="/heatmaps?page=' + encodeURIComponent(p.path) + '">' + esc(p.path) + "</a></td>"
        + "<td>" + nf(p.reads) + "</td><td>" + p.scroll + "%</td><td>" + dur(p.dwell_s) + "</td>"
        + "<td>" + p.completion + "%</td>"
        + '<td title="' + esc(tip) + '"><b style="color:' + band(p.resonance) + '">'
        + (p.resonance == null ? "—" : p.resonance) + "</b></td>"
        + "<td>" + esc(p.verdict) + "</td></tr>";
    }).join("");
  }

  function load() {
    if (!window.GS || !GS.api || !GS.site) return;
    var f = q("from"), t = q("to");
    GS.api("/plugin/content-intel/overview?site=" + encodeURIComponent(GS.site)
           + "&from=" + RANGE.from + "&to=" + RANGE.to)
      .then(function (r) {
        var d = (r && r.data) ? r.data : r;
        var gate = q("gate"), body = q("body");
        if (!d) return;
        if (!d.ok) {
          if (body) body.hidden = true;
          if (gate) { gate.hidden = false;
            gate.innerHTML = '<div class="cti-gate-in"><b>'+TT('cti.js.nothing_to_read_yet')+'</b><p>' + esc(d.reason || "") + "</p></div>"; }
          return;
        }
        if (gate) gate.hidden = true;
        if (body) body.hidden = false;
        var fl = q("floor");
        if (fl) fl.textContent = "Pages with fewer than " + (d.min_reads || 5)
          + " measured reads are excluded — a depth from two visits is an anecdote."
          + (d.notes && d.notes.behaviour ? " " + d.notes.behaviour : "");
        var ns = q("notshown");
        if (ns && d.not_shown) ns.textContent = d.not_shown;
        renderList("best", d.best); renderList("worst", d.worst); renderRows(d);
        /* ?page= used to be dropped on the floor here. The endpoint has no page filter, so nothing
           is faked: the row is found in what was just rendered, or the note says it is not here. */
        if (window.GS && GS.applyPageDeepLink) GS.applyPageDeepLink(root, {
          within: q("rows"),
          missText: 'No measured reads for ' + GS.dlParam("page") + ' in this range \u2014 pages under the read floor are excluded.'
        });
      })
      .catch(function (e) {
        var gate = q("gate");
        if (gate) { gate.hidden = false;
          gate.innerHTML = '<div class="cti-gate-in"><b>'+TT('cti.js.could_not_load')+'</b><p>'
            + esc((e && e.message) || "request failed") + "</p></div>"; }
      });
  }

  (function initRange() {
    function iso(d) { return d.toISOString().slice(0, 10); }
    var a = q("from"), b = q("to");
    if (a && !a.value) a.value = iso(new Date(Date.now() - 29 * 864e5));
    if (b && !b.value) b.value = iso(new Date());
    /* range reload handled by picker */
  })();

  document.addEventListener("gs:ready", load, { once: true });
  if (window.GS && GS.site) load();
})();
